<!-- @format -->

@for (entry of registrationsByStudyYear | slice: 0 : DEFAULT_STUDY_YEAR_COUNT; track entry) {
  <ng-container
    *ngTemplateOutlet="
      registrationsForStudyYear;
      context: { studyYear: entry.studyYear, registrations: entry.registrations, level: level }
    " />
}
@if (registrationsByStudyYear.length > DEFAULT_STUDY_YEAR_COUNT) {
  <sis-expandable [variant]="'link'" [level]="level" [title]="'PROFILE.SHOW_OLD_SEMESTERS' | translate">
    <ng-template sisExpandableContent>
      @for (entry of registrationsByStudyYear | slice: DEFAULT_STUDY_YEAR_COUNT; track entry) {
        <ng-container
          *ngTemplateOutlet="
            registrationsForStudyYear;
            context: { studyYear: entry.studyYear, registrations: entry.registrations, level: level + 1 }
          " />
      }
    </ng-template>
  </sis-expandable>
}

<ng-template #registrationsForStudyYear let-studyYear="studyYear" let-registrations="registrations" let-level="level">
  <sis-study-year-term-registrations
    [level]="level"
    [studyTermNamesByTermIndex]="studyTermNamesByTermIndex"
    [studyYearName]="studyYear + '–' + (studyYear + 1)"
    [termRegistrations]="registrations"
    [studyRightId]="studyRightId" />
</ng-template>
